export const data = {
    experience: [
      {
        title: "React Developer Intern",
        subTitle: "- Pune,Maharashtra",
        description:
          " Designed and developed front end components leveraging React for front-end implementation, and seamlessly integrating it with a backend database, enhancing data visualization and accessibility for end-users.",
      },
    ],
    education: [
      
      {
        title: "B.Tech -",
        subTitle: "Marathwada Mitramandal's College Of Engineering",
        description:
          "Bachelor of technology in IT",
        date:"2021-2025,CGPA:8.77"
      },
      {
        title: "HSC -",
        subTitle: "S.P. College",
        description:
          "12th Grade in Science",
        date:"2019-2021,Percentage:84%"
      },
      {
        title: "SSC -",
        subTitle: "Dnyanganga English Medium School",
        description:
          "10th Grade",
          date:"2009-2019,Percentage:84%"
      },
    ],
  };